import { Localizer } from "@/main/react/Types";

export type BookmarksSeriesLike = {
    title?: string | null;
    description?: string | null;
    bookmarksCollection?: boolean | null;
};

function normalizeText(value?: string | null): string | undefined {
    const trimmed = value?.trim();
    return trimmed ? trimmed : undefined;
}

export function isBookmarksSeries(series: BookmarksSeriesLike | null | undefined): boolean {
    if (!series) {
        return false;
    }

    return series.bookmarksCollection === true;
}

export function getUserFacingSeriesTitle(series: BookmarksSeriesLike | null | undefined, localizer: Localizer): string {
    if (isBookmarksSeries(series)) {
        return localizer("series.bookmarks.title");
    }

    return normalizeText(series?.title) ?? "";
}

export function getUserFacingSeriesDescription(series: BookmarksSeriesLike | null | undefined, localizer: Localizer): string {
    if (isBookmarksSeries(series)) {
        return localizer("series.bookmarks.description");
    }

    return normalizeText(series?.description) ?? "";
}

export function filterBookmarksSeries<T extends BookmarksSeriesLike>(series: readonly T[] | null | undefined): T[] {
    if (!Array.isArray(series) || series.length === 0) {
        return [];
    }

    return series.filter((item) => !isBookmarksSeries(item));
}
